import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dateHelper from '../../../../utils/dateHelper.js';
import Avatar from '../../../generic/Avatar.js';
import MessageParser from './MessageParser.js';
import supports from '../../../../utils/SupportHelper.js';
import CopyMessageButton from './CopyMessageButton.js';

class PlainMessage extends Component {
  /**
   * It's always a plain message.
   **/
  static test(_props) {
    return true;
  }

  render() {
    const { user, timestamp, content } = this.props;

    return (
      <div className="eyeson-chat-message">
        <div className="chat-avatar-wrap">
          <Avatar url={user.avatar} label={user.name} />
          {supports.ClipboardAPI && (
            <CopyMessageButton content={content} onEvent={this.props.onEvent} />
          )}
        </div>
        <div className="content">
          <span className="details">
            <strong className="username">{user.name}</strong>
            <span className="date">{dateHelper.formatTime(timestamp)}</span>
          </span>
          <MessageParser>{content}</MessageParser>
        </div>
      </div>
    );
  }
}

PlainMessage.propTypes = {
  user: PropTypes.object.isRequired,
  content: PropTypes.string.isRequired,
  timestamp: PropTypes.instanceOf(Date).isRequired,
};

export default PlainMessage;
